import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { translations } from "../translations";

const StyledFooter = styled(Box)(({ theme }) => ({
  background: "var(--overlay-footer)",
  borderRadius: "40px",
  padding: "100px 40px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  width: "calc(100% - 24px)",
  maxWidth: "1200px",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    borderRadius: "20px",
    padding: "20px",
  },
}));

const FooterRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "20px",
  },
}));

const FooterColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

const FooterTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  fontWeight: 600,
  color: "var(--text-black)",
}));

const FooterText = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: "var(--text-secondary)",
  lineHeight: "normal",
}));

const FooterLicense = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: "var(--text-secondary)",
  lineHeight: "normal",
  width: "100%",
}));

const FooterPolicy = styled(Link)(({ theme }) => ({
  ...theme.typography.caption,
  fontWeight: 600,
  color: "var(--text-black)",
  lineHeight: "normal",
  cursor: "pointer",
  textDecoration: "none",
}));

const PoliciesRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "24px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "8px",
  },
}));

export default function Footer() {
  const t = translations;

  return (
    <StyledFooter>
      <FooterRow>
        <FooterColumn>
          <FooterTitle>{t.office}</FooterTitle>
          <FooterText>{t.officeAddress}</FooterText>
          <FooterLicense>{t.license}</FooterLicense>
        </FooterColumn>
        <FooterColumn>
          <FooterTitle>{t.contacts}</FooterTitle>
          <FooterText>{t.email}</FooterText>
        </FooterColumn>
      </FooterRow>
      <PoliciesRow>
        <FooterPolicy to="/privacy-policy">{t.privacyPolicy}</FooterPolicy>
        <FooterPolicy to="/terms-and-conditions">
          {t.termsAndConditions}
        </FooterPolicy>
      </PoliciesRow>
    </StyledFooter>
  );
}
